export default __webpack_public_path__ + "static/media/digital7.136a98dc.jpg";